/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Action_ConfirmInputs */

const en_action_confirm = /** @type {(inputs: Action_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Confirm`)
};

const es_action_confirm = /** @type {(inputs: Action_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Confirmar`)
};

const fr_action_confirm = /** @type {(inputs: Action_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Confirmer`)
};

const de_action_confirm = /** @type {(inputs: Action_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bestätigen`)
};

const ja_action_confirm = /** @type {(inputs: Action_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`確認`)
};

const zh_action_confirm = /** @type {(inputs: Action_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`确认`)
};

const ar_action_confirm = /** @type {(inputs: Action_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تأكيد`)
};

const id_action_confirm = /** @type {(inputs: Action_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Konfirmasi`)
};

const it_action_confirm = /** @type {(inputs: Action_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conferma`)
};

const ru_action_confirm = /** @type {(inputs: Action_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Подтвердить`)
};

const pt_action_confirm = /** @type {(inputs: Action_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Confirmar`)
};

const ko_action_confirm = /** @type {(inputs: Action_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`확인`)
};

/**
* | output |
* | --- |
* | "Confirm" |
*
* @param {Action_ConfirmInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const action_confirm = /** @type {((inputs?: Action_ConfirmInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Action_ConfirmInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_action_confirm(inputs)
	if (locale === "es") return es_action_confirm(inputs)
	if (locale === "fr") return fr_action_confirm(inputs)
	if (locale === "de") return de_action_confirm(inputs)
	if (locale === "ja") return ja_action_confirm(inputs)
	if (locale === "zh") return zh_action_confirm(inputs)
	if (locale === "ar") return ar_action_confirm(inputs)
	if (locale === "id") return id_action_confirm(inputs)
	if (locale === "it") return it_action_confirm(inputs)
	if (locale === "ru") return ru_action_confirm(inputs)
	if (locale === "pt") return pt_action_confirm(inputs)
	return ko_action_confirm(inputs)
});